import React from 'react';
import QSUtil from '../../helpers/QSUtil';
import RenderContacto from './RenderContacto';

export default class ContainerContacto extends React.Component {
	referencia = null;
	hacia = null;
	accion = null;
	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);

		this.referencia = QSUtil.getValue('r');
		
		let selectSoy = 'dueño';
		if (this.referencia) {
			selectSoy = 'cliente';
			this.hacia = QSUtil.getValue('to');
			this.accion = QSUtil.getValue('a');
		}

		this.state = {
			selectSoy,
		}
	}

	handleChange(evt) {
		this.setState({selectSoy: evt.currentTarget.value});
	}

	render(){
		return <RenderContacto
			selectSoy={this.state.selectSoy}		
			onChange={this.handleChange}		
			to={this.props.to}
			referencia={this.referencia}
			hacia={this.hacia}
			accion={this.accion}
		/>
	}
}